import {Injectable, Inject} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpHeaders,
  HttpResponseBase,
  HttpErrorResponse
} from '@angular/common/http';
import {catchError, mergeMap} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {BASE_CLIENT, BaseClient} from '../client/base.client';
import {TokenService} from '../token/token.service';

@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService, @Inject(BASE_CLIENT) private baseclient: BaseClient) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token: string = this.tokenService.get().accessToken;
    console.log('token interceptor', token);
    const tokenType: string = this.tokenService.get().tokenType;
    if (this.baseclient.openDev === true) {
      return next.handle(req);
    }
    if (token) {
      const newReq: HttpRequest<any> = req.clone({
        headers: req.headers.append('Authorization', `${tokenType} ${token}`)
      });
      return next.handle(newReq);
    } else if (this.baseclient.ignores.includes(req.url)) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        mergeMap((event: any) => {
          if (event instanceof HttpResponseBase) {
            return this.handleData(event);
          }
          return of(event);
        }),
        catchError((err: HttpErrorResponse) => this.handleData(err)),
      );
    }
  }

  handleData(ev: HttpResponseBase): Observable<any> {
    if (ev instanceof HttpErrorResponse) {
      return throwError(ev);
    }
    return of(ev);
  }

}

